/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "enabledByDefault": true,
  "name": "Pick colors on stage with eyedropper",
  "description": "Allows the eyedropper in the costume editor to also pick colors from the stage.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "tags": [],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
